import { useMemo } from 'react';
import { Props as ReactApexChartProps } from 'react-apexcharts';
import { LangType } from '../../../../../../helpers/lang';
import { useLang } from '../../../../../../hooks/use-lang';
import { ChartProps } from '../../dashboard-components/dashboard-charts/use-dashboard-charts';
import { useFetchDashboardData } from '../../use-fetch-dashboard';
import { useMaxTime } from '../../use-max-time';
import { IgnoredTasksType, withBarSelection } from '../../dashboard-helpers';

interface DataType {
  categories: LangType[];
  ignored_tasks: IgnoredTasksType[];
  series: {
    overtime: number[];
  };
}

export const useDelayedOrders = (): ChartProps => {
  const { t, getLocale } = useLang();
  const { maxTime, onChangeMaxTime, debouncedMaxTime } = useMaxTime();

  const { list } = useFetchDashboardData(['delayed_tasks'], {
    ignore_time_over_than: debouncedMaxTime,
  });

  const data = list?.delayed_tasks as DataType;
  const overtimes = data?.series.overtime;

  const chartData: ReactApexChartProps = useMemo(() => {
    const categories = data?.categories.map((category) => getLocale(category)) || [];
    const series = overtimes?.length ? [{ name: t('Задержка'), data: overtimes }] : [];

    return {
      series,
      options: {
        chart: {
          type: 'bar',
          stacked: true,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 6.426,
            borderRadiusApplication: 'end',
            hideZeroBarsWhenGrouped: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        states: {
          hover: {
            filter: {
              type: 'none',
            },
          },
        },
        xaxis: {
          categories,
        },
        tooltip: {
          enabled: true,
          shared: false,
          intersect: true,
          hideEmptySeries: true,
          inverseOrder: true,
          y: {
            formatter: (val) => `${val} ${t('мин')}`,
          },
        },
        legend: {
          position: 'top',
          horizontalAlign: 'left',
        },
        colors: ['#FF9D8C'],
      },
    };
  }, [data, getLocale, t, overtimes]);

  return {
    series: chartData.series,
    options: withBarSelection(chartData).options,
    label: 'Заказы, отданные с задержкой',
    subLabel:
      'Диаграмма показывает заказы, по которым замечена задержка. Показано время задержки в минутах.',
    type: 'bar',
    invalidData: {
      maxTime,
      onChangeMaxTime,
      ignoredTasks: data?.ignored_tasks,
    },
  };
};
